import { Button } from '@/components/ui/button';

/**
 * Подвал списка: сколько показано из скольких и кнопка догрузки.
 *
 * Счётчик виден всегда, даже когда грузить больше нечего — иначе непонятно,
 * весь список перед тобой или обрезанный. Ровно на этом и погорели списки
 * админки: показывали 100 строк из 186 и ничем это не выдавали.
 */
export function ListFooter({
  loaded,
  total,
  hasMore,
  isLoading,
  onMore,
}: {
  loaded: number;
  total: number;
  hasMore: boolean;
  isLoading: boolean;
  onMore: () => void;
}) {
  if (loaded === 0) return null;

  return (
    <div className="flex items-center justify-between gap-4 pt-1">
      <span className="text-xs text-zinc-500">
        Показано <span className="font-mono tabular-nums text-zinc-300">{loaded}</span>
        {' из '}
        <span className="font-mono tabular-nums text-zinc-300">{total.toLocaleString('ru')}</span>
      </span>

      {hasMore && (
        <Button variant="outline" size="sm" onClick={onMore} disabled={isLoading}>
          {isLoading ? 'Загружаем…' : 'Показать ещё'}
        </Button>
      )}
    </div>
  );
}
